/* Local preview adapter for the native oléyoga testimonials-cards.js.
 * Keeps the native classes, timing, dots and transition. Autoplay additionally
 * pauses offscreen and respects simultaneous hover, focus and visibility states.
 */
(() => {
  const roots = document.querySelectorAll('[data-tc-reel]');
  if (!roots.length) return;

  const reduced =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  roots.forEach((root) => {
    const slides = Array.from(root.querySelectorAll('[data-tc-slide]'));
    const dots = Array.from(root.querySelectorAll('[data-tc-dot]'));

    if (reduced) {
      // The native reduced-motion CSS shows every citation as a static list.
      slides.forEach((slide) => slide.removeAttribute('aria-hidden'));
      return;
    }
    if (slides.length < 2) return;

    let index = Math.max(
      0,
      slides.findIndex((slide) => slide.classList.contains('is-active'))
    );
    const intervalMs = Number(root.dataset.tcInterval) || 5000;
    const autoplay = root.dataset.tcAutoplay !== 'false';
    let timer = null;
    let hovered = root.matches(':hover');
    let focused = root.contains(document.activeElement);
    let inView = !('IntersectionObserver' in window);

    const setActive = (next) => {
      index = (next + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        const on = i === index;
        slide.classList.toggle('is-active', on);
        slide.setAttribute('aria-hidden', on ? 'false' : 'true');
      });
      dots.forEach((dot, i) => {
        const on = i === index;
        dot.classList.toggle('is-active', on);
        dot.setAttribute('aria-selected', on ? 'true' : 'false');
        dot.tabIndex = on ? 0 : -1;
      });
    };

    const stop = () => {
      if (timer !== null) {
        clearInterval(timer);
        timer = null;
      }
    };

    const canRun = () => autoplay && inView && !document.hidden && !hovered && !focused;

    const start = () => {
      stop();
      if (!canRun()) return;
      timer = window.setInterval(() => {
        if (!canRun()) {
          stop();
          return;
        }
        setActive(index + 1);
      }, intervalMs);
    };

    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        setActive(i);
        start();
      });
      dot.addEventListener('keydown', (event) => {
        let next;
        const rtl = getComputedStyle(root).direction === 'rtl';
        if (event.key === 'ArrowRight') next = i + (rtl ? -1 : 1);
        else if (event.key === 'ArrowLeft') next = i + (rtl ? 1 : -1);
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = dots.length - 1;
        else return;

        event.preventDefault();
        next = (next + dots.length) % dots.length;
        setActive(next);
        dots[next].focus();
        start();
      });
    });

    if (autoplay) {
      root.addEventListener('mouseenter', () => {
        hovered = true;
        stop();
      });
      root.addEventListener('mouseleave', () => {
        hovered = false;
        start();
      });
      root.addEventListener('focusin', () => {
        focused = true;
        stop();
      });
      root.addEventListener('focusout', (event) => {
        focused = root.contains(event.relatedTarget);
        if (!focused) start();
      });
      document.addEventListener('visibilitychange', start);

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            inView = entry.isIntersecting;
            start();
          });
        }, { threshold: 0 });
        observer.observe(root);
      }
    }

    setActive(index);
    start();
  });
})();
